import React, { Fragment, useState } from 'react';
import { Link } from "react-scroll";

const Navbar = ({ showMobileNavbar }) => {

  const [toggle, setToggle] = useState(false);

  const menu = () => {
    setToggle(!toggle);
    if (toggle) {
      document.getElementById("nav").classList.add("visible");
    }
    else {
      document.getElementById("nav").classList.remove("visible");
    }
  }

  return (
    <Fragment>
    {showMobileNavbar === false ? (
      <section className="navbar">
        <div className="nav-items">
          <Link activeClass="active" to="home" spy={true} smooth={true} duration={600}>HOME</Link>
        </div>
        <div className="nav-items">
          <Link activeClass="active" to="about" spy={true} smooth={true} duration={600} offset={-62}>ABOUT</Link>
        </div>
        <div className="nav-items">
          <Link activeClass="active" to="projects" spy={true} smooth={true} duration={600} offset={-62}>PROJECTS</Link>
        </div>
        <div className="nav-items">
          <Link activeClass="active" to="experience" spy={true} smooth={true} duration={600} offset={-62}>EXPERIENCE</Link>
        </div>
        <div className="nav-items">
          <Link activeClass="active" to="contact" spy={true} smooth={true} duration={600} offset={-100}>CONTACT</Link>
        </div>
      </section>
    ) : (
        <section className="mobileNavbar">
          <div className="menuIcon" onClick={menu}>
            <div>
              <span className="iconify menu" data-icon="heroicons-outline:menu" data-inline="false"></span>
            </div>
          </div>
            <div id="nav" className={`menuData ${toggle ? "visible" : ""}`}>
            <div className="nav-items">
                <Link activeClass="active" to="home" spy={true} smooth={true} duration={600} onClick={menu} isDynamic={true}>HOME</Link>
            </div>
            <div className="nav-items">
                <Link activeClass="active" to="about" spy={true} smooth={true} duration={600} offset={-64} onClick={menu} isDynamic={true}>ABOUT</Link>
            </div>
            <div className="nav-items">
                <Link activeClass="active" to="projects" spy={true} smooth={true} duration={600} offset={-64} onClick={menu} isDynamic={true}>PROJECTS</Link>
            </div>
            <div className="nav-items">
                <Link activeClass="active" to="experience" spy={true} smooth={true} duration={600} offset={-64} onClick={menu} isDynamic={true}>EXPERIENCE</Link>
            </div>
            <div className="nav-items">
                <Link activeClass="active" to="contact" spy={true} smooth={true} duration={600} onClick={menu} isDynamic={true}>CONTACT</Link>
            </div>
          </div>
        </section>
    )}
    </Fragment>
  )
}

export default Navbar;
